import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";

@Entity({ many: "conditionsUser" })
export default class RemoteCondition {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public value: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/conditionProgress/entities/RemoteCondition.ts